import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import ShopMapList from "./shop";
import CabinetList from "./cabinet";

export default function ListShopCabinetManage({
    getAllShop,
    getAllCabinet,
    listShop,
    loading,
    setLoading,
    listCabinet = [],
}) {
    const [selectedTab, setSelectedTab] = useState("1");

    const { t } = useTranslation()

    const items = [
        {
            key: '1',
            label: t('listShop'),
            children: <ShopMapList getAllShop={getAllShop} listShop={listShop} loading={loading} setLoading={setLoading} />,
        },
        {
            key: '2',
            label: t('listCabinet'),
            children: <CabinetList getAllCabinet={getAllCabinet} listCabinet={listCabinet} loading={loading} setLoading={setLoading} />,
        },
    ];

    const onChange = (key) => {
        setSelectedTab(key);
    };

    // Load shops on component mount
    useEffect(() => {
        getAllShop();
        getAllCabinet();
    }, []);

    return (
        <Tabs tabPosition="left" activeKey={selectedTab} items={items} onChange={onChange} />
    );
}
